// export type SexEnum = 'M' | 'F' | 'U'

export enum SingpassTypeEnum {
  singpass = 'SP',
  corppass = 'CP',
}